import React, { useState } from 'react'
import { Rating } from 'react-simple-star-rating'

const RatingStars = ({name}) => {
  const [rating, setRating] = useState(0)

  const handleRating = (rate) => {
    setRating(rate)
  }

  return (
    <>
      <Rating
        onClick={handleRating}
        allowFraction={false}
        SVGclassName="inline-block"
      />
      <input type="hidden" value={rating} name={name} onChange={() => {}}/>
    </>
  )
}

export default RatingStars